export const featureKey = 'localeManager';
export const defaultBcpLocale = 'en_US';
export const defaultSiLocale = 'US';
